import { RenderContext3D } from "../RenderContext3D";
import { Command } from "./Command";
import { RenderElement } from "../RenderElement";
import { LayaGL } from "../../../../layagl/LayaGL";
import { Vector4 } from "../../../../maths/Vector4";
import { Laya3DRender } from "../../../RenderObjs/Laya3DRender";
import { Camera } from "../../Camera";
import { ScreenQuad } from "./geometry/ScreenQuad";
import { Pool } from "../../../../utils/Pool";
const _defaultOffsetScale = new Vector4(0, 0, 1, 1);
export class BlitFrameBufferCMD {
    static __init__() {
        BlitFrameBufferCMD.shaderdata = LayaGL.renderDeviceFactory.createShaderData(null);
    }
    static create(source, dest, viewport, offsetScale = null, shader = null, shaderData = null, subShader = 0) {
        var cmd;
        cmd = BlitFrameBufferCMD._pool.take();
        cmd._source = source;
        cmd._dest = dest;
        cmd._offsetScale = offsetScale;
        cmd.setshader(shader, subShader, shaderData);
        cmd._source && cmd._texture_size.setValue(source.width, source.height, 1.0 / source.width, 1.0 / source.height);
        cmd._viewPort = viewport;
        return cmd;
    }
    constructor() {
        this._source = null;
        this._dest = null;
        this._offsetScale = null;
        this._texture_size = null;
        this._shader = null;
        this._shaderData = null;
        this._subShader = 0;
        this._viewPort = null;
        this._transform3D = Laya3DRender.Render3DModuleDataFactory.createTransform(null);
        this._renderElement = new RenderElement();
        this._renderElement.setTransform(this._transform3D);
        this._renderElement.setGeometry(ScreenQuad.instance);
        this._renderElement._renderElementOBJ.isRender = true;
        this._texture_size = new Vector4();
    }
    set shaderData(value) {
        this._shaderData = value || BlitFrameBufferCMD.shaderdata;
        this._renderElement._renderElementOBJ.materialShaderData = this._shaderData;
    }
    setshader(shader, subShader, shaderData) {
        this._shader = shader || Command._screenShader;
        this._subShader = subShader || 0;
        this.shaderData = shaderData;
        this._renderElement.renderSubShader = this._shader.getSubShaderAt(this._subShader);
    }
    run() {
        if (!this._source || !this._viewPort)
            return;
        var source = this._source;
        var dest = this._dest;
        var shaderData = this._shaderData;
        let context = RenderContext3D._instance;
        var viewport = this._viewPort;
        let vph = RenderContext3D.clientHeight - viewport.y - viewport.height;
        if (LayaGL.renderEngine._screenInvertY) {
            context.changeViewport(viewport.x, viewport.y, viewport.width, viewport.height);
            context.changeScissor(viewport.x, viewport.y, viewport.width, viewport.height);
        }
        else {
            context.changeViewport(viewport.x, vph, viewport.width, viewport.height);
            context.changeScissor(viewport.x, vph, viewport.width, viewport.height);
        }
        shaderData.setTexture(Command.SCREENTEXTURE_ID, source);
        shaderData.setVector(Command.SCREENTEXTUREOFFSETSCALE_ID, this._offsetScale || _defaultOffsetScale);
        source && (shaderData.setVector(Command.MAINTEXTURE_TEXELSIZE_ID, this._texture_size));
        if (dest) {
            shaderData.removeDefine(RenderContext3D.GammaCorrect);
        }
        else {
            shaderData.addDefine(RenderContext3D.GammaCorrect);
        }
        this._renderElement.setGeometry(ScreenQuad.InvertInstance);
        if (LayaGL.renderEngine._screenInvertY) {
            this._renderElement.setGeometry(ScreenQuad.instance);
        }
        context.destTarget = dest;
        context._contextOBJ.cameraUpdateMask = Camera._updateMark;
        context.drawRenderElement(this._renderElement._renderElementOBJ);
    }
    recover() {
        BlitFrameBufferCMD._pool.recover(this);
        this._source = null;
        this._dest = null;
        this._offsetScale = null;
        this._shader = null;
        this._shaderData = null;
        this._viewPort = null;
    }
}
BlitFrameBufferCMD._pool = Pool.createPool(BlitFrameBufferCMD);
